import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

export const getMinLabour = createAsyncThunk(
    "labour/getMin",
    async ({search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/Labour/getAll",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                let newObj = [];
                response.data.data.map((item) =>
                    newObj.push({
                        value: item.LabourID,
                        label: item.LabourName,
                    })
                );
                return {data: newObj};
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const getLabour = createAsyncThunk(
    "labour/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/Labour/getAll",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const insertLabour = createAsyncThunk(
    "labour/insert",
    async ({LabourName}, thunkAPI) => {
        let formData = new FormData();
        formData.append("LabourName", LabourName);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/Labour/insert",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

export const updateLabour = createAsyncThunk(
    "labour/update",
    async ({LabourName, LabourID, status}, thunkAPI) => {
        let formData = new FormData();
        formData.append("LabourName", LabourName);
        formData.append("LabourID", LabourID);
        formData.append("Status", status);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+"Master/Labour/update",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + user.Token,
                        Accept: "*/*",
                    },
                }
            );
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
);

const initialState = {
    message: "",
    minData: [],
    isMinFetching: false,
    isMinSuccess: false,
    isMinError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
};

export const labourSlice = createSlice({
    name: "labour",
    initialState,
    reducers: {},
    extraReducers: {
        [getMinLabour.fulfilled]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinSuccess = true;
            state.minData = payload.data;
            return state;
        },
        [getMinLabour.rejected]: (state, {payload}) => {
            state.isMinFetching = false;
            state.isMinError = true;
            state.errorMessage = payload.message;
        },
        [getMinLabour.pending]: (state) => {
            state.isMinFetching = true;
        },

        [getLabour.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getLabour.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getLabour.pending]: (state) => {
            state.isGetFetching = true;
        },

        // INSERT
        [insertLabour.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertLabour.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertLabour.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateLabour.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateLabour.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateLabour.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});

export const labourSelector = (state) => state.labour;
